import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { PickTicketNewFlowDetailListTemplate } from "themes/application/pick-ticket-new-flow/pages";
import { PickTicketNewFlowDetailListViewStore } from "application/pick-ticket-new-flow/stores";

@setCurrentView(rootStore => new PickTicketNewFlowDetailListViewStore(rootStore), "pickTicketNewFlowDetailListViewStore")
@observer
class PickTicketNewFlowDetailList extends React.Component {
    render() {
        return <PickTicketNewFlowDetailListTemplate {...this.props} />;
    }
}

export default PickTicketNewFlowDetailList;